module.exports = __webpack_public_path__ + "img/box.7f88e829.svg";